'use client';

import dynamic from 'next/dynamic';
import PageLoader from '@/components/common/PageLoader';

const PrompterPageClient = dynamic(
    () => import('@/components/client/prompter/PrompterPageClient'),
    {
        loading: () => <PageLoader fullPage={true} />,
        ssr: false,
    }
);

export default function PrompterDynamicPage() {
    return <PrompterPageClient />;
}
